export { default } from "./src/teamwork-graph";

export type { UniformTeamworkGraphProps } from "./src/teamwork-graph";
